import React from 'react'
import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';

const containerStyle = {
  width: '100%',
  height: '100%'
};



function GoogMap({ userLocation, zoom }) {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: "AIzaSyCDRJE8BYBlmHVuqTZl0xyvoV0pKtj_00o"
    // googleMapsApiKey: "AIzaSyDKSfBNFewTDoXVabl1SoAiS5fnNXvhTnQ"
  })

  const [map, setMap] = React.useState(null)

  const onLoad = React.useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds();
    if (userLocation) {
      bounds.extend(userLocation)
    
      map.fitBounds(bounds);
      setMap(map)
    } else {
      map.fitBounds(bounds);
      setMap(map)
    }

    // const NEPoint = window.google.maps.geometry.spherical.computeOffset(userLocation, 1000, 45);
    // const SWPoint = window.google.maps.geometry.spherical.computeOffset(userLocation, 1000, 225);
    
    // bounds.extend(NEPoint);
    // bounds.extend(SWPoint);
  }, [])

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null)
  }, [])

  return isLoaded ? (
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={userLocation}
        zoom={zoom}
        onLoad={onLoad}
        onUnmount={onUnmount}
      >
        { /* Child components, such as markers, info windows, etc. */ }
        {userLocation && <Marker position={userLocation} />}
      </GoogleMap>
  ) : <></>
}

export default GoogMap


